<!--人文美育-视频库管理-->
<template>
    <div class="studio_nav_content" >
        <!--五馆合一-->
        <el-scrollbar class="page-mode" v-show="showMode==='page'">
            <div class="form-box">
                <el-row style="height: 40px">
                    <el-col style="height: 40px" :span="8"></el-col>
                    <el-col style="height: 40px" :span="8">
<!--                        <div class="head-container-top">五馆合一</div>-->
                    </el-col>
                    <el-col style="height: 40px" :span="8">
                        <el-form-item class="pull-right">
                            <el-input v-model="keyword" placeholder="请输入关键字" class="input-with-select">
                                <template #append>
                                    <el-button type="primary" @click="handleQuery" style="background-color: #0d55a4;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="new-museum-container">
                <div class="new-museum-item">
                    <div class="new-museum-img" @click="viewMuseum('1')">
                        <div class="item-container-25">
                            <svg t="1773888078949" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9795" width="64" height="36"><path d="M950.2 192.1c-60.7-34.4-136.4-54.8-218.7-54.8-82.4 0-158.4 20.7-219 55.1 0 0-0.1 0-0.1 0.1-60.6-34.5-136.6-55.2-218.9-55.2-82.3 0-158 20.3-218.7 54.7-6.3 3.6-10.1 10.5-10.1 17.9v650.2c0 11.8 9.4 20.3 19.8 20.3 2.9 0 5.9-0.7 8.7-2.1 57.3-28.4 126.1-44.9 200.3-44.9 73.5 0 141.9 16.5 198.9 44.4 3.6 1.7 7.1 3.5 10.5 5.3a20.39 20.39 0 0 0 19.2 0c0.1 0 0.1-0.1 0.2-0.1 0.5-0.2 0.9-0.5 1.4-0.8 3-1.5 5.9-3 8.9-4.5 57-27.8 125.4-44.4 198.9-44.4 74.2 0 143 16.5 200.3 44.9 2.9 1.4 5.8 2.1 8.7 2.1 10.4 0 19.8-8.5 19.8-20.3V210c0-7.4-3.8-14.3-10.1-17.9z m-218.7 602c-38.1 0-75.7 4.3-111.7 12.6-30.3 6.7-59.5 16.2-87.2 28.3v-35c2.8-1.4 5.5-2.9 8.5-4.2 56.8-27.7 122.7-42.3 190.4-42.3 38 0 75.3 4.5 110.9 13.4 27.9 7 54.4 16.6 78.9 28.6V831c-25.7-10.6-52.7-18.9-80.7-24.9-35.1-7.9-71.8-12-109.1-12zM103.8 831v-35.5c24.5-12 50.9-21.6 78.8-28.5 35.6-9 72.9-13.5 110.9-13.5 67.8 0 133.6 14.6 190.4 42.4 2.9 1.5 5.7 2.9 8.5 4.3V835c-29.6-13-61.1-22.9-93.8-29.7-34-7.3-69.3-11.1-105.1-11.1-33.6 0-66.7 3.3-98.6 9.7-31.7 6.1-62.3 15.2-91.1 27.1z m627.7-654.7c37 0 73.3 4.5 107.8 13.3 29.3 7.5 56.8 17.9 82 31.1V774c-55.1-25.4-120.1-40-189.8-40-73.4 0-141.8 16.5-198.9 44.4V225.9c27.6-15.6 58.2-27.7 91-36.2 34.6-8.9 70.9-13.4 107.9-13.4z m-545.7 13.3c34.4-8.9 70.7-13.3 107.7-13.3s73.3 4.5 108 13.4c32.7 8.4 63.3 20.5 90.9 36.1v552.6C435.3 750.5 366.9 734 293.5 734c-69.6 0-134.6 14.6-189.7 40V220.7c25.2-13.2 52.7-23.7 82-31.1z" fill="#0d54a4" p-id="9796"></path></svg>
                        </div>
                        <div class="item-container-15 font-1">
                            阅读拓展馆
                        </div>
                        <div class="item-container-10 font-2">
                            以阅读为根 启智润心
                        </div>
                        <div class="item-container-20 font-3">
                            多元阅读资源 养成终身习惯
                        </div>
                        <div class="item-container-10 ">
                            <div class="hum-item">
                                配套阅读资源
                            </div>
                        </div>
                        <div class="item-container-10">
                            <div class="hum-item">
                                书香润心营
                            </div>
                        </div>
                    </div>
                </div>
                <div class="new-museum-item">
                    <div class="new-museum-img" @click="viewMuseum('3')">
                        <div class="item-container-25">
                            <svg t="1773889181122" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11292" width="80" height="42"><path d="M405.9 712.2H246.1l18 18V585.8v-69.2c0-11.7 0.4-23.5 1.6-35.1 0.3-2.7 0.5-5.5 1-8.2-0.9 4.8 0 0.2 0.1-0.6 0.2-1.4 0.4-2.7 0.6-4.1 0.9-5.8 2.1-11.6 3.4-17.4 2.5-10.9 5.5-21.7 9.2-32.3 1.7-5 3.6-10 5.6-15 0.3-0.8 1.8-5.1 0.2-0.6 0.4-1.2 1.1-2.4 1.6-3.6l3.9-8.4c4.8-9.9 10.1-19.5 15.9-28.8 2.8-4.4 5.7-8.8 8.7-13.1 1.5-2.1 3-4.3 4.6-6.4 0.8-1.1 1.6-2.1 2.4-3.1-3 3.9 0.6-0.8 1.2-1.5 6.8-8.5 14.1-16.7 21.8-24.4 7.4-7.4 15.2-14.4 23.3-21 1-0.8 2-1.6 3.1-2.5 0.7-0.5 4.2-3.2 0.5-0.4 2.1-1.6 4.2-3.2 6.3-4.7 4.6-3.3 9.3-6.5 14.1-9.6 9.2-5.9 18.8-11.3 28.6-16.2 4.7-2.3 9.5-4.9 14.4-6.7-4.5 1.5-0.2 0.1 0.6-0.2 1.2-0.5 2.5-1 3.7-1.5l8.7-3.3c10.5-3.8 21.3-6.9 32.2-9.5 5.3-1.2 10.6-2.3 16-3.3 2.7-0.5 5.4-0.9 8.1-1.3 0.9-0.1 5.5-1 0.6-0.1 1.8-0.3 3.7-0.5 5.5-0.7 12.3-1.4 24.7-1.8 37.1-1.8h229.4l-18-18v138.3c0 18.3 0 37.1-3.2 55.2 0.7-4.1-0.1 0.5-0.3 2-0.2 1.6-0.5 3.2-0.7 4.7-0.6 3.8-1.3 7.6-2 11.4-1.3 6.9-2.9 13.7-4.6 20.5-3.5 13.7-7.7 27.1-12.8 40.3l-3.9 9.9c-0.3 0.9-1.1 3.2 0.3-0.6-0.2 0.6-0.5 1.2-0.8 1.8-0.8 1.8-1.6 3.7-2.4 5.5-2.9 6.4-6 12.8-9.3 19-6.4 12.3-13.5 24.2-21.3 35.6-3.8 5.6-7.8 11.1-11.9 16.6-0.5 0.7-1.1 1.4-1.6 2.1 2.5-3.2 0.9-1.2 0.4-0.5-1.1 1.4-2.2 2.7-3.3 4.1-2.2 2.7-4.4 5.4-6.7 8.1-9 10.5-18.5 20.4-28.5 29.8-5.1 4.8-10.3 9.4-15.7 13.9-2.5 2.1-5.1 4.2-7.6 6.2-0.7 0.5-1.4 1.1-2.1 1.6 0.4-0.3 3.1-2.4 0.5-0.4-1.4 1.1-2.8 2.1-4.2 3.2-11.3 8.4-23 16.1-35.2 23.1-12 7-24.4 13.3-37.2 18.8-1.6 0.7-4.5 2-1.2 0.5-1.6 0.7-3.3 1.4-4.9 2-3.3 1.3-6.6 2.6-10 3.8-6.7 2.5-13.5 4.8-20.3 6.8-13.8 4.2-27.9 7.6-42.1 10.2-3.1 0.6-6.3 1.1-9.5 1.6-1.8 0.3-3.6 0.6-5.4 0.8 5-0.5-1.7 0.2-2.7 0.3-7.4 0.9-14.7 1.5-22.1 1.9-7.4 0.7-14.7 0.9-21.9 0.9-9.4 0-18.4 8.3-18 18 0.4 9.7 7.9 18 18 18 60.9-0.1 121.1-14.4 175.6-41.7 52.6-26.4 98.4-65.1 134.2-111.6 35.4-46 60.4-100.2 72.1-157 5.4-26.5 8.2-53.5 8.2-80.5v-37.1-104.8-2.2c0-9.7-8.2-18-18-18H556.4c-29.9 0-59.5 2.2-88.5 9.4-45.6 11.3-87.8 33.2-124.2 62.8-35 28.4-63.9 65.1-83.5 105.6-21 43.3-32 90.8-32.1 139V730.2c0 9.7 8.2 18 18 18h159.8c9.4 0 18.4-8.3 18-18-0.4-9.7-7.9-18-18-18z" fill="#0d54a4" p-id="11293"></path><path d="M264 810.7v-50.5c0-2.6 0-5.1 0.1-7.7 0.1-2.3 0.3-4.6 0.5-7 0.4-4.4-0.6 3.1-0.1 0.3 0.3-1.5 0.5-3.1 0.8-4.6 2.1-11.4 5.5-22.6 9.7-33.4 0.5-1.4 1.1-2.7 1.6-4.1 1.1-2.8-0.3 0.9-0.5 1.2 0.4-0.6 0.6-1.4 0.9-2.1 1.4-3.2 2.8-6.3 4.3-9.4 2.9-6.1 6.1-12 9.5-17.8 3.6-6.2 7.4-12.3 11.4-18.2 1.9-2.8 3.8-5.5 5.8-8.2 1.1-1.5 2.2-3.1 3.4-4.6 0.5-0.7 1-1.4 1.5-2-1.3 1.6-1.5 1.9-0.1 0.1 9.3-11.6 19.2-22.6 30.1-32.7 5.4-5 11-9.7 16.7-14.3 0.8-0.6 2.3-2.2-0.6 0.4 0.6-0.6 1.4-1.1 2.1-1.5l4.2-3c3.1-2.2 6.3-4.4 9.6-6.5 6.8-4.3 13.8-8.3 21.1-11.8l5.7-2.7c0.7-0.3 1.6-0.8 2.3-1-1.9 0.5-2.5 1-0.2 0.1 3.7-1.5 7.4-2.9 11.2-4.1 7.8-2.5 15.7-4.5 23.8-5.8 0.8-0.1 1.7-0.2 2.5-0.4 2.3-0.4-3.9 0.4-0.4 0.1 2.1-0.2 4.2-0.5 6.3-0.6 3.8-0.3 7.6-0.4 11.5-0.4 9.4 0 18.4-8.3 18-18-0.4-9.8-7.9-18-18-18-64.4 0-122.7 38-163.5 85.5-19.5 22.7-36.4 47.9-48.5 75.2-10.3 23.2-18.4 47.9-18.6 73.5-0.1 18 0 36 0 54 0 9.4 8.3 18.4 18 18 9.7-0.4 17.9-7.9 17.9-18z" fill="#0d54a4" p-id="11294"></path></svg>
                        </div>
                        <div class="item-container-15 font-1">
                            非遗文化馆
                        </div>
                        <div class="item-container-10 font-2">
                            以文化为魂 守正创新
                        </div>
                        <div class="item-container-20 font-3">
                            触摸千年文脉 建立文化自信
                        </div>
                        <div class="item-container-10 ">
                            <div class="hum-item">
                                非遗实践资源
                            </div>
                        </div>
                        <div class="item-container-10">
                            <div class="hum-item">
                                非遗匠心营
                            </div>
                        </div>
                    </div>
                </div>
                <div class="new-museum-item">
                    <div class="new-museum-img" @click="viewMuseum('2')">
                        <div class="item-container-25">
                            <svg t="1773889385082" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="17629" width="60" height="48"><path d="M426.265287 702.494826c-1.926623 0-4.094073-0.722484-5.539041-2.408278-2.889934-3.130762-2.889934-7.947319 0.240828-10.837254l410.611477-392.30856c6.261524-6.020696 9.873942-14.208843 10.11477-23.119473 0.240828-8.91063-3.130762-17.098777-9.151458-23.360301-6.020696-6.261524-14.208843-9.873942-23.119474-10.11477-8.91063-0.240828-17.098777 3.130762-23.360301 9.151458l-413.019755 394.957667c-3.130762 2.889934-7.706491 2.889934-10.837253-0.240828-2.889934-3.130762-2.889934-7.947319 0.240828-10.837253L775.706491 238.660395c9.151458-8.91063 21.433678-13.486359 34.197554-13.245531 12.763876 0.240828 24.805268 5.53904 33.715899 14.690498 8.91063 9.151458 13.486359 21.433678 13.245531 34.197554-0.240828 12.763876-5.53904 24.805268-14.690499 33.715899L431.5635 700.327375c-1.444967 1.444967-3.37159 2.167451-5.298213 2.167451z" fill="#0d54a4" p-id="17630"></path><path d="M175.5635 855.902164c-3.853246 0-7.224835-3.130762-7.465664-6.984008-5.057385-78.509878 12.763876-137.5127 53.222954-175.081844 58.521167-54.427093 141.847601-44.071496 145.460019-43.58984 4.094073 0.481656 6.984008 4.334901 6.502352 8.428975-0.481656 4.094073-4.334901 6.984008-8.428975 6.502352-1.204139-0.240828-80.195673-9.873942-133.177798 39.736594-36.84666 34.438382-52.982126 89.347131-48.406397 163.040452 0.240828 4.094073-2.889934 7.706491-6.984008 7.947319h-0.722483z" fill="#0d54a4" p-id="17631"></path><path d="M262.74318 868.66604c-26.972719 0-56.835372-4.334901-89.347131-13.004704-4.094073-0.963311-6.502352-5.298213-5.298213-9.151458 0.963311-4.094073 5.298213-6.502352 9.392286-5.298213 79.232361 20.952023 140.643462 15.412982 182.547507-16.857949 58.039511-44.553151 58.521167-125.712135 58.521167-126.675447 0-4.094073 3.37159-7.465663 7.465663-7.465663s7.465663 3.37159 7.465663 7.465663c0 3.612418-0.722484 89.587959-64.541862 138.476011-27.93603 21.674506-63.337723 32.511759-106.20508 32.51176z" fill="#0d54a4" p-id="17632"></path><path d="M426.265287 702.494826c-1.926623 0-3.853246-0.722484-5.298213-2.167451L363.650047 643.251176c-2.889934-2.889934-2.889934-7.706491 0-10.837253 2.889934-2.889934 7.706491-2.889934 10.837253 0l57.317027 57.317027c2.889934 2.889934 2.889934 7.706491 0 10.837253-1.685795 1.204139-3.612418 1.926623-5.53904 1.926623zM458.054563 669.019755c-1.926623 0-3.853246-0.722484-5.539041-2.408278l-53.945437-55.631232c-2.889934-2.889934-2.889934-7.706491 0.240828-10.837253 2.889934-2.889934 7.706491-2.889934 10.837253 0.240827l53.945437 55.631233c2.889934 2.889934 2.889934 7.706491-0.240828 10.837253-1.444967 1.444967-3.37159 2.167451-5.298212 2.16745zM708.033866 345.828786c-0.963311 0-1.926623-0.481656-2.649106-1.204139-1.444967-1.444967-1.444967-3.853246 0-5.298212l59.484478-59.484478c1.444967-1.444967 3.853246-1.444967 5.298213 0 1.444967 1.444967 1.444967 3.853246 0 5.298212l-59.484478 59.484478c-0.722484 0.722484-1.685795 1.204139-2.649107 1.204139zM658.182502 415.668862c-0.963311 0-1.926623-0.481656-2.649106-1.20414-1.444967-1.444967-1.444967-3.853246 0-5.298212l69.840075-69.840075c1.444967-1.444967 3.853246-1.444967 5.298213 0 1.444967 1.444967 1.444967 3.853246 0 5.298212l-69.840075 69.840075c-0.722484 0.722484-1.685795 1.204139-2.649107 1.20414z" fill="#0d54a4" p-id="17633"></path></svg>
                        </div>
                        <div class="item-container-15 font-1">
                            科技艺术馆
                        </div>
                        <div class="item-container-10 font-2">
                            以审美为形 融真创关
                        </div>
                        <div class="item-container-20 font-3">
                            习得艺术特长 全员成果展演
                        </div>
                        <div class="item-container-10 ">
                            <div class="hum-item">
                                艺术特长资源
                            </div>
                        </div>
                        <div class="item-container-10">
                            <div class="hum-item">
                                科艺启心营
                            </div>
                        </div>
                    </div>
                </div>
                <div class="new-museum-item">
                    <div class="new-museum-img" @click="viewMuseum('4')">
                        <div class="item-container-25">
                            <svg t="1773889515869" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20614" width="44" height="44"><path d="M426.3 181.4l-70.7 40.8c-6.5 3.8-11.2 10.1-12.7 17.5-3 14.5-11.8 27.7-25.5 35.7s-29.6 9-43.7 4.3c-7.1-2.4-14.9-1.5-21.5 2.3l-56.4 33.6c-6.4 3.7-8.6 12-4.9 18.4l67.3 116.6c3.7 6.4 12 8.6 18.4 4.9l56.4-33.6c6.5-3.8 11.2-10.1 12.7-17.5 3-14.5 11.8-27.7 25.5-35.7 46.6-26.9 84.2 24.7 92.8 39.7l53.8 93.3c10.6 74.8 22.5 107 71.3 176.4 88.1 125.3 79.1 139.1 93.8 165.2 14.8 26.1 40.7 36.9 58.6 26.5l77.2-44.6c18-10.4 21.6-38.2 6.4-64-15.3-25.8-31.7-25-96.2-163.9C693 520 671 494.8 611 447.8l-53.8-93.3c-23.7-41-16.2-83.9 30-110.5 46.6-26.9 78.2-30.5 117.8-9l16.3-22.5c-51-82.9-224.7-71.6-295-31.1z m278.4 427.2c65.6 141.3 83.7 143 97.4 166.2 3.8 6.4 9 23.8 3.4 27l-77.2 44.6c-5.7 3.3-18.1-10-21.7-16.4-13.2-23.4-5.8-40.1-95.3-167.5-42.9-61-54.5-90-63.6-147l61.5-35.5c44.8 36.4 64.1 61 95.5 128.6z m-130.9-388c-56.9 32.8-72.5 90.7-39.8 147.3l53.8 93.3-46.6 26.9-53.8-93.3c-25.9-44.9-77.5-79.6-129.6-49.5-19.8 11.4-33.8 30.9-38.2 53.1l-45.1 27.1-53.9-93.3 44.6-27.1c21.9 7.3 45.8 4.9 65.6-6.5 19.8-11.4 33.8-30.9 38.2-53.1l70.7-40.8c32-18.5 90.8-29 143-25.6 19.7 1.3 48.1 5.1 73.9 16.2-26.1-0.4-52.8 8-82.8 25.3z" fill="#0d54a4" p-id="20615"></path></svg>
                        </div>
                        <div class="item-container-15 font-1">
                            劳动实践营
                        </div>
                        <div class="item-container-10 font-2">
                            以实践为基 砺行成长
                        </div>
                        <div class="item-container-20 font-3">
                            习得劳动技能 培养责任担当
                        </div>
                        <div class="item-container-10 ">
                            <div class="hum-item">
                                劳动实践资源
                            </div>
                        </div>
                        <div class="item-container-10">
                            <div class="hum-item">
                                劳趣砺心营
                            </div>
                        </div>
                    </div>
                </div>
                <div class="new-museum-item">
                    <div class="new-museum-img" @click="viewMuseum('5')">
                        <div class="item-container-25">
                            <svg t="1773889599790" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21767" width="36" height="36"><path d="M512 0C278.8 0 89 189.7 89 423c0 228.6 391.5 580.5 408.1 595.4 4.2 3.8 9.5 5.6 14.8 5.6s10.6-1.9 14.8-5.6C543.5 1003.5 935 651.6 935 423 935 189.7 745.2 0 512 0z m0 971.5C440.3 904.8 133.6 608.4 133.6 423c0-208.7 169.8-378.4 378.4-378.4S890.4 214.3 890.4 423c0 185.3-306.7 481.8-378.4 548.5z" fill="#0d54a4" p-id="21768"></path><path d="M512 200.3c-122.7 0-222.6 99.9-222.6 222.6S389.3 645.6 512 645.6 734.6 545.7 734.6 423 634.7 200.3 512 200.3z m0 400.7c-98.2 0-178.1-79.9-178.1-178.1s79.9-178 178.1-178S690.1 324.8 690.1 423 610.2 601 512 601z" fill="#0d54a4" p-id="21769"></path></svg>
                        </div>
                        <div class="item-container-15 font-1">
                            研学体验馆
                        </div>
                        <div class="item-container-10 font-2">
                            以体验为径 知行合一
                        </div>
                        <div class="item-container-20 font-3">
                            线上预热 线下实地探索
                        </div>
                        <div class="item-container-10 ">
                            <div class="hum-item">
                                研学配套资源
                            </div>
                        </div>
                        <div class="item-container-10">
                            <div class="hum-item">
                                研学悟心营
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-scrollbar>
        <!--五馆课程-->
        <div class="detail-mode" v-if="showMode==='museumCourse'">
            <museum-course :museum-key="this.museumKey" @change-mode="changeModel"/>
        </div>

        <!--搜索视频-->
        <div class="detail-mode" v-if="showMode==='searchVideo'">
            <search-humanity-video :info-word="this.keyword" @change-mode="changeModel"/>
        </div>

    </div>
</template>

<script>
import { listClassLibrary } from "@/api/admin/classLibrary";
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/public";
import subjectFusion from "@/components/resourceCentre/subjectFusion.vue";
import museumCourse from "@/components/resourceCentre/museumCourse.vue";
import searchHumanityVideo from "@/components/resourceCentre/searchHumanityVideo";

export default {
    name: "humanityFiveMuseumEdit",
    components: {subjectFusion,museumCourse,searchHumanityVideo},
    data() {
        return {
            showMode:'page',
            subjectFusionMode:'subjectFusion',
            museumCourseMode:'museumCourse',
            searchVideoMode:'searchVideo',
            serviceUrl,
            keyword:'',
            subjectList: [],
            periodList: [],
            gradeList: [],
            libraryList: [],
            queryParams: {
                className: '',
                periodKey: '1',
                gradeKey: '',
                subjectKey: '',
            },
            classId:'',
            museumKey:'',
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryDict();
        this.queryClassLibrary();
    },
    mounted(){},
    methods: {
        queryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data;
                    this.changePeriod();
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.queryClassLibrary()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.queryClassLibrary()
        },
        queryClassLibrary(){
            listClassLibrary(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.libraryList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        handleQueryClass(){
            this.queryClassLibrary();
        },
        handleQuery(){
            this.showMode = this.searchVideoMode;
            this.$emit('change-mode',this.showMode);
        },
        viewSubjectFusion(item){
            this.classId = item.classId;
            this.$emit('change-mode',this.showMode);
            this.showMode = this.subjectFusionMode
        },
        viewMuseum(mk){
            this.museumKey = mk;
            this.$emit('change-mode',this.showMode);
            this.showMode = this.museumCourseMode
        },
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        },
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.form-box{
    padding: 10px 20px 0 0;
    height: 40px;
}
.new-museum-container{
    width: 100%;
    height: calc(100vh - 160px);
    padding: 0 20px 0 20px;
    box-sizing: border-box;
    display: flex;
}
.new-museum-item{
    width: 20%;
    height: 100%;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
    display: grid; place-items: center;

}
.new-museum-img{
    width: 100%;
    height: 45%;
    cursor: pointer;
    border: 1.5px solid #0d55a4;
}

.item-container-30{
    width: 100%;
    height: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-container-20{
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-container-25{
    width: 100%;
    height: 25%;
    display: flex;
    justify-content: center;
    align-items: center;

}
.item-container-15{
    width: 100%;
    height: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-container-10{
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.font-1{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    font-family: sans-serif;
}
.font-2{
    font-size: 14px;
    color: #0d55a4;
}
.font-3{
    font-size: 14px;
    color: #b3b2b4;
}
.hum-item{
    width: 90%;
    height: 80%;
    border: 1px solid #ffbf6b;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: #ffbf6b;
}
</style>